import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthProviderType } from 'src/app/enums/authProviderType';
import launchContext from 'src/app/models/launchContext';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isLoginButtonVisible = true;
  isAuth0Enabled = false;
  isAadEnabled = false;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.isAuth0Enabled = environment.auth0Enabled;
    this.isAadEnabled = environment.aadEnabled;

    // Hide Login button in Microsoft Teams, as we use SSO here.
    if (launchContext.isTeamsMode) {
      this.isLoginButtonVisible = false;
    }
  }

  ngOnInit(): void {
    const providerParam = this.route.snapshot.queryParamMap.get('provider');
    const provider = providerParam ? providerParam.toLowerCase() : null;

    if (provider === 'auth0') {
      this.loginWithEmail();
    }
  }

  async loginWithEmail() {
    await this.authService.login(AuthProviderType.Auth0);
  }

  async loginWithAad() {
    await this.authService.login(AuthProviderType.AzureActiveDirectory);
  }
}
